export default __webpack_public_path__ + "static/media/logo-skyground-white.0f53940a.svg";